var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"export-pdf-btn",attrs:{"color":"primary","outlined":"","small":_vm.small,"loading":_vm.loading,"disabled":!_vm.data},on:{"click":_vm.generatePDF}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("mdi-file-pdf-box")]),_vm._v(" "+_vm._s(_vm.text || 'PDF')+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }